// extracted by mini-css-extract-plugin
export default {"input":"InputFiles_input__4l1pj","button":"InputFiles_button__f1WYz","info":"InputFiles_info__kPiPO","wrapper":"InputFiles_wrapper__KBfUq","overlay":"InputFiles_overlay__q+zF6"};